import { Product, Site } from './';
import { ResourceType } from './ResourceType';

export interface Stock {
    id?: number;
    unusedReason?: string;
    freeStockReason?: string;
    description?: string;
    source?: StockPointData;
    destination?: StockPointData;
    originQuantity: number;
    site: Site;
    product: Product;
    packAlias?: string;
    salesPrice?: number;
    objectStockValue?: number;
    objectPlanValue?: number;
    objectValueStatus?: string;
    reviewDeadline?: string;
    sourceTypeId?: number;
    sourceType?: ResourceType;
    externalData?: string;
    unusedWeight?: number;
    consignmentId?: number;
    consignment?: string;

    // calced
    agreementStatusName?: string;
}

export interface StockPointData {
    siteId: number;
    site: Site;
    time: string;
    project?: string;
    owner?: string;
    status?: string;
    object?: string;
    objectCode?: string;
    count?: number;
    stockCategory?: string;
    area?: string;
    storageCode?: string;
    storageName?: string;
    areaPlaceCode?: string;
}

export interface FreeStockAgreement {
    id?: number;
    productId?: string;
    siteId?: string;
    packAlias?: string;
    owner?: string;
    project?: string;
    object?: string;
    quantity?: number;
    price?: number;
    description?: string;
    reason?: string;
    agreement?: number;
    product?: Product;
    site?: Site;
    type?: string;
    externalData?: string;

    sourceTypeId?: number;
    sourceType?: ResourceType;
}

export enum StocksAction {
    ACCEPT = 'accept',
    REFUSE = 'refuse',
}
